import { render, staticRenderFns } from "./LottoProfit.vue?vue&type=template&id=18b84598&scoped=true&"
import script from "./LottoProfit.vue?vue&type=script&lang=ts&"
export * from "./LottoProfit.vue?vue&type=script&lang=ts&"
import style0 from "./LottoProfit.vue?vue&type=style&index=0&id=18b84598&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b84598",
  null
  
)

export default component.exports